import React from 'react';
import Loading from '../../loading';
import Server from '../../../functions/server'
import $ from "jquery";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Buttons from '@material-ui/core/Button';
import { Button, Icon } from 'semantic-ui-react'
import AddPartAlias from './addpartalias';
import EditPartAlias from './editalias';
import DeleteAlias from './deleteAlias';

class View extends React.Component {

  state = {
    load: false, message: '', data: [],
    addAliasDialog: false, maxWidth: 'sm', fullWidth: true,
  }

  componentDidMount() {
    this.getBrandById();
  }

  getBrandById() {
    let context = this;
    context.setState({ load: true, addAliasDialog: false, message: 'Getting Branch Details!!!' });
    let data1 = {'id': this.props.id};
    $.ajax({
      type: 'POST', data: data1,
      url: Server() + 'spares/getbrandbyid.php',
      success: function(data) {
        let part_alias = 0; let dnp = 0; let mrp = 0; let tax = 0;
        try {
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            data[i].sino = i + 1;
            part_alias = data[i].part_alias;
            mrp = data[i].mrp; dnp = data[i].dnp;
            tax = data[i].tax;
          }
          mrp = Number(mrp); dnp = Number(dnp);
          tax = Number(tax);
          mrp = mrp + (mrp * tax)/100; dnp = dnp + (dnp * tax)/100;
          mrp = mrp.toFixed(2); dnp = dnp.toFixed(2);
          context.setState({ data, part_alias, mrp, dnp, load: false, tax })
        } catch (e) {
          context.setState({ load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!!')
      }
    });
  }

  handleClose = () => {
   this.setState({ addAliasDialog: false, editAliasDialog: false, deleteDialog: false, });
  };

  render() {
    const { data, addAliasDialog, editAliasDialog, deleteDialog, load, message } = this.state;
    return (
      <div>
      <Loading load={load} message={message} />
      <table width='100%' id='table'>
          <tr id='tablehead'>
            <th style={{fontSize: 14, color: 'white', width: '10%'}}><center>S.No</center></th>
            <th style={{fontSize: 14, color: 'white'}}>Part Alias</th>
            <th style={{fontSize: 14, color: 'white'}}>DNP</th>
            <th style={{fontSize: 14, color: 'white'}}>MRP</th>
            <th style={{fontSize: 14, color: 'white'}}>TAX</th>
            <th style={{fontSize: 14, color: 'white'}}>Date</th>
          </tr>
          { data.map((row) => {
              let mrp = row.mrp; let dnp = row.dnp;
              let tax = row.tax; let mrptaxablePrice;
              let dnptaxablePrice;
              try {
                mrp = Number(mrp); dnp = Number(dnp);
                tax = Number(tax);
                mrptaxablePrice = mrp + (mrp * (tax/100));
                mrptaxablePrice = mrptaxablePrice.toFixed(2);
                dnptaxablePrice = dnp + (dnp * (tax/100));
                dnptaxablePrice = dnptaxablePrice.toFixed(2);
                mrp = mrp.toFixed(2);
                dnp = dnp.toFixed(2);
              } catch (e) {

              }
              let date = row.timestamp.split(' ')[0];
              let time = row.timestamp.split(' ')[1];
              date = date.split('-')[2]+"-"+date.split('-')[1]+"-"+date.split('-')[0]+" "+time;
              return (
                <tr id='rowselect'>
                  <td style={{fontSize: 14}}>{row.sino}</td>
                  <td style={{fontSize: 14}}>{row.part_alias}</td>
                  <td style={{fontSize: 14}}>{"Rs:"+dnptaxablePrice+"(Rs:"+dnp+")"}</td>
                  <td style={{fontSize: 14}}>{"Rs:"+mrptaxablePrice+"(Rs:"+mrp+")"}</td>
                  <td style={{fontSize: 14}}>{row.tax}</td>
                  <td style={{fontSize: 14}}>{date}</td>
                </tr>
              )
            })
          }
        </table>
        <br/>

        <Button primary icon labelPosition='left' onClick={ () => { this.setState({ addAliasDialog: true }) }}>
          <Icon name='plus' />
          Add Alias With MRP & DNP
        </Button>

        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}  open={addAliasDialog}
            aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Add Allias</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <AddPartAlias brandId={this.props.brandId} partno={this.props.partno}
                  getBrandById={this.getBrandById.bind(this)} type='view' tax={this.state.tax}
                  part_alias={this.state.part_alias} dnp={this.state.dnp}
                  mrp={this.state.mrp}
                  id={this.props.id} handleClose={this.handleClose.bind(this)} />
              </DialogContentText>
            </DialogContent>
          </Dialog>
        </React.Fragment>
      </div>
    );
  }
}

export default View;
